import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Non-binding server quote: follow-up rate → membership discount → coupon. Server recomputes on booking.
export default function usePriceQuote({ amount, bookingType, email, couponCode, doctorId, consultationType, date, enabled = true }) {
  const [quote, setQuote] = useState(null);
  useEffect(() => {
    if (!enabled || !amount) { setQuote(null); return; }
    let cancelled = false;
    axios.post(`${API}/pricing/quote`, { amount, booking_type: bookingType, patient_email: email || null, coupon_code: couponCode || null, doctor_id: doctorId || null, consultation_type: consultationType, date: date || null }, { withCredentials: true })
      .then((r) => { if (!cancelled) setQuote(r.data); })
      .catch(() => { if (!cancelled) setQuote(null); });
    return () => { cancelled = true; };
  }, [amount, bookingType, email, couponCode, doctorId, consultationType, date, enabled]);
  return quote;
}

export function MemberDiscountLine({ quote, testId = "member-discount-line" }) {
  if (!quote?.member_discount) return null;
  return (
    <div className="flex justify-between text-emerald-800 text-xs" data-testid={testId}>
      <span>Membership benefit ({quote.member_plan || "member"} −{quote.member_pct}%):</span>
      <span className="font-semibold">−₹{quote.member_discount}</span>
    </div>
  );
}
